import React from 'react';
import { AutomationGlyph, GLYPH_SIZE, MessageGlyph, TaskEndBar, TaskStartGlyph } from './glyphs';
import { timelineColors, timelineFontWeight } from './tokens';

const Item = ({ children }: { children: React.ReactNode }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      fontSize: 12,
      color: timelineColors.textMuted,
      whiteSpace: 'nowrap'
    }}
  >
    {children}
  </div>
);

const IconSlot = ({ children }: { children: React.ReactNode }) => (
  <div style={{ width: GLYPH_SIZE, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
    {children}
  </div>
);

export const Legend = ({
  participantColor,
  automationColor
}: {
  participantColor: string;
  automationColor: string;
}) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 18, padding: '10px 0', flexWrap: 'wrap' }}>
    <span
      style={{
        fontSize: 10,
        fontWeight: timelineFontWeight.title,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: timelineColors.textMuted
      }}
    >
      Legend
    </span>
    <Item>
      <IconSlot>
        <MessageGlyph color={participantColor} foreground={timelineColors.surface} />
      </IconSlot>
      Message — sent that day
    </Item>
    <Item>
      <IconSlot>
        <TaskStartGlyph color={participantColor} foreground={timelineColors.surface} />
      </IconSlot>
      Task — start
    </Item>
    <Item>
      <IconSlot>
        <TaskEndBar color={timelineColors.ink} height={18} />
      </IconSlot>
      Task — end
    </Item>
    <Item>
      <IconSlot>
        <AutomationGlyph color={automationColor} foreground={timelineColors.surface} />
      </IconSlot>
      Automation — runs that day
    </Item>
    <Item>
      <IconSlot>
        <TaskStartGlyph color={participantColor} foreground={timelineColors.surface} variableStart />
      </IconSlot>
      Variable start — condition, field, or start-date change
    </Item>
    <Item>
      <span style={{ width: 20, height: 2, background: timelineColors.ink, flexShrink: 0 }} />
      Message bundled with a task
    </Item>
    <Item>
      <span style={{ width: 20, height: 0, borderTop: `2px dashed ${timelineColors.ink}`, flexShrink: 0 }} />
      Triggers another item
    </Item>
  </div>
);
